import { HOME_ROUTE, LOGIN_ROUTE } from "@/utils/const";
import { getCookie } from "@/utils/cookies";
import { Navigate } from "react-router-dom";

const NotFoundRoute = () => {
  const isAuth = getCookie("isAuth") === "true";

  if (isAuth) {
    return <Navigate to={HOME_ROUTE} replace />;
  }

  return <Navigate to={LOGIN_ROUTE} replace />;
};

export default NotFoundRoute;
